import React from "react";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import RetailJobTitlesGrid from "./views/RetailJobTitlesGrid";

export default function RetailJobTitlesWrapper() {
     return (
          <>
               <MainLeftTitle title="Job Titles" />

               <RetailJobTitlesGrid />
          </>
     );
}
